import { useEffect, useRef } from 'react';

export function useSessionTimeoutAdmin(onTimeout, idleLimitMs = 6 * 60 * 60 * 1000) {
  const timerRef = useRef(null);
  useEffect(() => {
    const timerStart = localStorage.getItem('sessionTimerStart');
    let timeLeft = idleLimitMs;
    if (timerStart) {
      const elapsed = Date.now() - Number(timerStart);
      timeLeft = Math.max(idleLimitMs - elapsed, 0);
    } else {
      localStorage.setItem('sessionTimerStart', Date.now().toString());
    }
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      localStorage.removeItem('sessionTimerStart');
      onTimeout('idle');
    }, timeLeft);

    return () => clearTimeout(timerRef.current);
  }, [onTimeout, idleLimitMs]);
}